/* import $ from "jquery"; */


document.addEventListener('DOMContentLoaded', function() {
	let body = document.querySelector('body');

	if ( document.querySelector('#menu-open') ){
		document.querySelector('#menu-open').addEventListener('click', function(event) {
			body.className += " navopen";
			event.preventDefault();
		});
	}
	if ( document.querySelector('#menu-close') ){
		document.querySelector('#menu-close').addEventListener('click', function(event) {
			body.className = body.className.replace(" navopen", "");
			event.preventDefault();
		});
	}
	if ( document.querySelector('span.nav-close') ){
		document.querySelector('span.nav-close').addEventListener('click', function() {
			body.className = body.className.replace(" navopen", "");		
		});
	}

	if ( document.querySelectorAll('.contact-box').length ) {
		let cboxes = document.querySelectorAll('.contact-box');
		cboxes.forEach(function(box){
			box.querySelector('.contact-box__figure').addEventListener('click', function(){
				box.classList.toggle('is-active');
				box.classList.toggle('slideInRight');
			});
			box.querySelector('.contact-box__button-close').addEventListener('click', function(){
				box.classList.toggle('is-active');
				box.classList.toggle('slideInRight');
			});
		}); 
	}

	document.querySelector('#search').addEventListener('click', function(event){
		if (document.querySelector('#search').className.indexOf(' open') >= 0) {
			document.querySelector('#search').className = document.querySelector('#search').className.replace(' open', '');
		}
		else {
			document.querySelector('#search').className += ' open';
		}
		document.querySelector('.searchoverlay').classList.toggle('open');
		document.querySelector('.searchoverlay .searchbox__input').focus();
		event.preventDefault();
	});

	function preventWordbreak (word) {
		document.querySelectorAll('p, li, a, td, th, h1, h2, h3, span').forEach(function(div){
			if (div.innerText.indexOf(word) >= 0 && div.innerHTML.indexOf("<nobr>"+word+"</nobr>") == -1 ) {
				div.innerHTML = div.innerHTML.replaceAll(word, '<nobr>'+word+'</nobr>').replaceAll(" "+word, ' <nobr>'+word+'</nobr>').replaceAll(word+" ", '<nobr>'+word+'</nobr> ');
			}

		});			
	}
	preventWordbreak('DOGEWO21');
});

window.addEventListener('scroll',function() {
	let body = document.querySelector('body');
	if ( window.scrollY >= 200 ){
		if (body.className.indexOf(" fixedheader") < 0){
		body.className += " fixedheader";
		}
	}
	else {
		if ( body.className != null ) {
			body.className = body.className.replace(" fixedheader","");
		}
	}
});
